module.exports = __webpack_public_path__ + "img/icon-home-720.8e2545f1.png";